import { render } from "./AllReviews.vue?vue&type=template&id=0c2c6775&scoped=true"
import script from "./AllReviews.vue?vue&type=script&lang=js"
export * from "./AllReviews.vue?vue&type=script&lang=js"

import "./AllReviews.vue?vue&type=style&index=0&id=0c2c6775&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c2c6775"]])

export default __exports__